import script from "./lk-mobile-notice-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./lk-mobile-notice-modal.vue?vue&type=script&setup=true&lang=ts"

import "./lk-mobile-notice-modal.vue?vue&type=style&index=0&id=f711d29e&lang=scss"

const __exports__ = script;

export default __exports__